import CustomModal from '@/components/CustomModal';
import { useFormatText } from '@/hooks/useFormatText';

export interface IConfirmationModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  descriptionPrefix: string;
  descriptionSuffix?: string;
  entityName?: string;
  entityFallback?: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
  isDestructive?: boolean;
  dataTestId?: string;
}

const ConfirmationModal = ({
  isOpen,
  setIsOpen,
  title,
  descriptionPrefix,
  descriptionSuffix,
  entityName,
  entityFallback,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  isLoading = false,
  isDestructive = false,
  dataTestId = 'confirmation-modal',
}: IConfirmationModalProps) => {
  const { formatText } = useFormatText();

  const handleCancel = () => {
    setIsOpen(false);
    onCancel?.();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  if (!isOpen) return null;

  return (
    <CustomModal
      setIsOpen={setIsOpen}
      className="w-150 max-w-[90vw]"
      isFooter
      position="center"
      dataTestId={dataTestId}
      cancelButtonProps={{
        label: cancelLabel || formatText('common.actions.cancel'),
        onClick: handleCancel,
        className: 'px-1.5! border-none! shadow-none! ',
      }}
      confirmButtonProps={{
        label: confirmLabel,
        variant: 'primary',
        desructive: isDestructive,
        onClick: handleConfirm,
        loading: isLoading,
      }}
    >
      <div className="w-full text-start space-y-4">
        <h2 className="text-xl leading-7 tracking-[-0.2px]">
          {formatText(title)}
        </h2>
        <p className="text-neutral-secondary">
          {formatText(descriptionPrefix)}{' '}
          {entityName ? (
            <span className="font-bold text-neutral-primary">{entityName}</span>
          ) : (
            <span>
              {entityFallback ? formatText(entityFallback || '') : ''}
            </span>
          )}
          {formatText('common.delete-confirmation.question')}
          {descriptionSuffix && (
            <>
              <br />
              {formatText(descriptionSuffix)}
            </>
          )}
        </p>
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
